import { FetchArgs } from '@reduxjs/toolkit/query'
import { assign, isString } from 'lodash-es'
import {
  BOGUS_TOKEN_SERVICE_ERROR_CODE,
  bogusTokenService,
} from '@/api/utils/bogus-token-service'
import { paramsSerializer } from '@/api/utils/params-serializer'
import { HeaderName } from '@/constants/header-name'
import { actions } from '@/store/state.modal'
import { isClient } from '@/utils/is-client'
import { BaseQuery } from '@/utils/redux-toolkit'

const bogusTokenInjector: (baseQuery: BaseQuery) => BaseQuery =
  (baseQuery: BaseQuery) => async (args, api, extraOptions) => {
    if (isString(args)) {
      const url = `/api${args.trim()}`
      const bogusToken = await bogusTokenService.generate(url)

      const fetchArgs: FetchArgs = {
        url: args,
        headers: {
          [HeaderName.IkalaBogusToken]: bogusToken,
        },
      }

      const result = await baseQuery(fetchArgs, api, extraOptions)

      if (
        result.meta?.response?.status === BOGUS_TOKEN_SERVICE_ERROR_CODE &&
        isClient()
      ) {
        api.dispatch(actions.openModal('needReload'))
      }

      return result
    }

    let url = `/api${args.url.trim()}`

    // 參考 fetchBaseQuery 實作建立請求網址
    // https://github.com/reduxjs/redux-toolkit/blob/master/packages/toolkit/src/query/fetchBaseQuery.ts#L270
    if (args.params) {
      const queryString = paramsSerializer(args.params)
      const divider = url.includes('?') ? '&' : '?'
      url += divider + queryString
    }

    const bogusToken = await bogusTokenService.generate(url, args.body)

    args.headers = assign({}, args.headers, {
      [HeaderName.IkalaBogusToken]: bogusToken,
    })

    const response = await baseQuery(args, api, extraOptions)

    if (
      response.meta?.response?.status === BOGUS_TOKEN_SERVICE_ERROR_CODE &&
      isClient()
    ) {
      api.dispatch(actions.openModal('needReload'))
    }

    return response
  }

export default bogusTokenInjector
